import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S32MapViewSection } from '../components/interactive-sections/S32MapView';
import { getBackgroundColorInput, getPaddingInputs } from '../utils/builderSharedInputs';
import { backgroundColorOptions } from '../utils/builderColorOptions';

Builder.registerComponent(S32MapViewSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S32MapView,
    friendlyName: 'S32 MapView',
    inputs: [
        ...getBackgroundColorInput({
            defaultValue: 'WhiteOff',
            backgroundColorsList: backgroundColorOptions,
        }),
        ...getPaddingInputs(),
    ],
});
